import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { EmailOption } from './components/email-option';
import * as Styled from './styles';
import * as SX from './sx';
import type { Option, EmailNotificationSettingsProps as Props } from './types';

export const EmailNotificationSettings = memo(({ className }: Props) => {
  const options: Option[] = [
    {
      title: 'Instant Notification',
      description:
        'Get an email notification each time a data request is completed. ',
    },
    {
      title: 'Daily Summary',
      description:
        'Receive a daily summary of all data requests completed in a day',
    },
  ];
  return (
    <Styled.Wrapper
      className={classnames('EmailNotificationSettings', className)}
      sx={SX.root}
    >
      <Typography sx={SX.description}>
        Enable the toggle to adjust email notifications for messages received
        after a data request is completed
      </Typography>
      <Stack direction="row" gap={1.5}>
        {options.map((i) => (
          <EmailOption key={i.title} item={i} />
        ))}
      </Stack>
    </Styled.Wrapper>
  );
});

EmailNotificationSettings.displayName = 'EmailNotificationSettings';
